import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import powercabsLogo from '../assets/powercabs-logo-black.svg';
import rightColumn from '../assets/right-column.jpg';
import { FaEyeSlash, FaEye } from 'react-icons/fa';

const Login = () => {
  const [email, setEmail] = useState('');
  const [pass, setPassword] = useState('');
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const API_KEY = process.env.REACT_APP_API_KEY || 'fallback_value';

  useEffect(() => {
    if (localStorage.getItem('authToken')) {
      navigate('/dashboard');
    }
  }, [navigate]);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const loginData = new URLSearchParams({
      email,
      pass,
      key: API_KEY,
      type: 'login',
    });

    try {
      const response = await fetch('https://app.mindstreamsoft.com/login.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: loginData,
      });

      const responseText = await response.text();

      let responseData;
      try {
        responseData = JSON.parse(responseText);
      } catch (error) {
        throw new Error('Invalid response from server.');
      }

      const userId = responseData.user?.cid;
      const userEmail = responseData.user?.email;
      const companyName = responseData.user?.name;
      const userKey = API_KEY;

      if (!userId || !userKey) {
        throw new Error(
          responseData.message || 'Login failed. Please try again.'
        );
      }

      localStorage.setItem('authToken', userId);
      localStorage.setItem('key', API_KEY);
      localStorage.setItem('name', companyName);
      localStorage.setItem('email', userEmail);

      navigate('/dashboard');
    } catch (err) {
      console.error('Login Error:', err.message);
      setError(err.message);
    }
  };

  return (
    <div className='container-fluid vh-100 g-0'>
      <div className='row h-100 g-0'>
        <div className='col-lg-6 d-flex flex-column justify-content-center px-5'>
          <div className='mx-lg-5 px-lg-5'>
            <div className='mb-4'>
              <img src={powercabsLogo} alt='PowerCabs Logo' className='mb-3' />
            </div>
            <h2
              className='mb-3'
              style={{ fontSize: '42px', fontWeight: '700' }}
            >
              Sign in
            </h2>
            <p className='mb-4 text-muted'>
              Please login to continue to your account.
            </p>

            {error && <div className='alert alert-danger'>{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className='form-group mb-3'>
                <label htmlFor='email'>Email</label>
                <input
                  type='email'
                  id='email'
                  className='form-control'
                  placeholder='Johndoe@gmail.com'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className='form-group mb-3 position-relative'>
                <label htmlFor='password'>Password</label>
                <input
                  type={passwordVisible ? 'text' : 'password'}
                  id='password'
                  className='form-control'
                  placeholder='Password'
                  value={pass}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <span
                  className='position-absolute'
                  style={{
                    right: '15px',
                    top: '32px',
                    cursor: 'pointer',
                    color: '#9a9a9a',
                  }}
                  onClick={togglePasswordVisibility}
                >
                  {passwordVisible ? (
                    <FaEye style={{ color: '#9a9a9a' }} />
                  ) : (
                    <FaEyeSlash style={{ color: '#9a9a9a' }} />
                  )}
                </span>
              </div>
              <button
                type='submit'
                className='btn w-100'
                style={{ backgroundColor: '#f37a20', color: '#fff' }}
              >
                Sign in
              </button>
            </form>
          </div>
        </div>

        <div className='col-lg-6 d-none d-lg-block position-relative h-100 overflow-hidden'>
          <div className='h-100 w-100'>
            <img
              src={rightColumn}
              alt='Login Visual'
              className='img-fluid h-100 w-100 object-fit-cover'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
